import type { LearnerFormRequest } from './type';

export const defaultLearnerForm: LearnerFormRequest = {
  lastName: '',
  firstName: '',
  nickname: '',
  name: '',
  gender: '',
  phone: '',
  email: '',
  height: undefined,
  weight: undefined,
  bmi: undefined,
  password: '',
  institutionId: '',
  yearOfBirth: null,
  dayOfBirth: null,
  monthOfBirth: null,
};
